require('./cmWalletBuySuccess.scss');
const PropTypes = require('prop-types');
// @ vendors
const React = require('react');

// @ components
const CmWizardSuccess = require('../../cmWizardSuccess/cmWizardSuccess');
const {
    OneLineSymbolAmount,
} = require('commonsComponents/oneLineSymbolAmount');
const FormattedTextWithComponents = require('components/broker/brokerFormattedTextWithComponents/brokerFormattedTextWithComponents');
const { ContentBox } = require('commonsComponents/contentBox');
const CmValidationSummary = require('../../cmValidationSummary/cmValidationSummary');

// @ helpers
const { FormattedText, formatText, getLanguage } = require('core/i18n').i18n;
const { getLastNChars } = require('utilities/stringHelper');
const {
    formatAmountObject,
    getPlainAmountObject,
} = require('utilities/currencyHelper');
const {
    getTranslationIntervenerFromType,
} = require('../../../utilities/intervenerNameHelper');
const { recordLink } = require('utilities/tagging');

// @ constants
const {
    CM_API_CENTER,
    CM_API_ENTERPRISE_NUMBER,
    CM_WIZARD_FIRST_STEP,
    CM_WIZARD_SECOND_STEP,
    CM_WIZARD_THIRD_STEP,
    CM_BROKER_PG_URL,
    CM_CUSTOM_WALLET_CONFIG_URL,
    CM_BUY_TYPE_MONEY,
    CM_PROC_BUY_FUND,
    CM_PROC_BUY_FUND_ORDERS_OK,
    CM_PROC_BUY_FUND_ORDERS_NOK,
} = require('wealth-cm/constants/constants');

class CmWalletBuySuccess extends React.Component {
    componentDidMount() {
        const successful = this.buildOKList();
        const notSuccessful = this.buildNOKList();
        recordLink(
            CM_PROC_BUY_FUND,
            `${CM_PROC_BUY_FUND_ORDERS_OK} ${successful.size}, ${CM_PROC_BUY_FUND_ORDERS_NOK} ${notSuccessful.size}`,
        );
    }

    buildIntervenersInfo(interveners) {
        const intervenersBlock = interveners.map((intervener, index) => (
            <div
                key={index}
                className="cm-wallet-buy-step2__info-item col-lg-12 col-sm-12 col-xs-12"
            >
                <span className="cm-wallet-buy-step2__info-title">
                    {intervener.get('name')}
                </span>
                <span className="cm-wallet-buy-step2__info-body">
                    {getTranslationIntervenerFromType(
                        intervener.get('type').toUpperCase(),
                    )}
                </span>
            </div>
        ));

        return intervenersBlock;
    }

    buildIntervenersInfoFromFunds(interveners) {
        const intervenersBlock = interveners.map((intervener, index) => (
            <div
                key={index}
                className="cm-wallet-buy-step2__info-item col-lg-12 col-sm-12 col-xs-12"
            >
                <span className="cm-wallet-buy-step2__info-title">
                    {intervener.get('nomInterviniente')}
                </span>
                <span className="cm-wallet-buy-step2__info-body">
                    {getTranslationIntervenerFromType(
                        intervener
                            .get('tipoIntervencion')
                            .trim()
                            .toUpperCase(),
                    )}
                </span>
            </div>
        ));

        return intervenersBlock;
    }

    buildOKList() {
        const { immCmWalletBuy } = this.props;
        const isTransferWithMoney = immCmWalletBuy.getIn([
            'steps',
            CM_WIZARD_FIRST_STEP,
            'isTransferWithMoney',
        ]);
        const transferOrderResultOkOutput = isTransferWithMoney
            ? immCmWalletBuy.getIn([
                  'steps',
                  CM_WIZARD_THIRD_STEP,
                  'confirmFundsFromFundsWithMoneyData',
                  'portfolioTransferConfirmationOutput',
                  'transferOrderResultOkOutput',
              ])
            : [];
        const orderConfirmationSuccessful = immCmWalletBuy.getIn([
            'orderConfirmationSuccessful',
        ]);
        const successful = isTransferWithMoney
            ? transferOrderResultOkOutput.concat(orderConfirmationSuccessful)
            : orderConfirmationSuccessful;

        return successful;
    }

    buildFundsDetails(successful) {
        const { immCmWalletBuy, onLegalDocumentClick } = this.props;
        const isTransferWithMoney = immCmWalletBuy.getIn([
            'steps',
            CM_WIZARD_FIRST_STEP,
            'isTransferWithMoney',
        ]);
        const originFunds = immCmWalletBuy.getIn([
            'steps',
            CM_WIZARD_SECOND_STEP,
            'originFund',
        ]);

        const successfulDiv = (
            <div className="cm-model-wallet-success__successful-div">
                <h2 className="cm-model-wallet-success__subtitle">
                    <FormattedText value="brokerCM-walletBuySuccessOrdersOk" />
                </h2>
                <CmValidationSummary
                    portfolio={successful}
                    hideDocument={true}
                    onLegalDocumentClick={onLegalDocumentClick}
                    isTransferWithMoney={isTransferWithMoney}
                    originFunds={originFunds}
                    success={true}
                />
            </div>
        );

        return <div>{successfulDiv}</div>;
    }

    buildNOKList() {
        const { immCmWalletBuy } = this.props;
        const typeMoney = immCmWalletBuy.get('buyType') === CM_BUY_TYPE_MONEY;
        const isTransferWithMoney = immCmWalletBuy.getIn([
            'steps',
            CM_WIZARD_FIRST_STEP,
            'isTransferWithMoney',
        ]);

        let notSuccessful;
        let orchestratorKoValidationAndConfirmation;

        if (isTransferWithMoney) {
            const validOrderResultOutputNoK = immCmWalletBuy.getIn([
                'steps',
                CM_WIZARD_THIRD_STEP,
                'confirmFundsFromFundsWithMoneyData',
                'portfolioOrderValidationOutput',
                'validOrderResultOutputNoK',
            ]);
            const transferOrderResultKoOutput = immCmWalletBuy.getIn([
                'steps',
                CM_WIZARD_THIRD_STEP,
                'confirmFundsFromFundsWithMoneyData',
                'portfolioTransferConfirmationOutput',
                'transferOrderResultKoOutput',
            ]);
            orchestratorKoValidationAndConfirmation = validOrderResultOutputNoK.concat(
                transferOrderResultKoOutput,
            );
        }

        if (typeMoney) {
            notSuccessful = immCmWalletBuy
                .getIn(['orderValidation', 'validOrderResultOutputNoK'])
                .concat(
                    immCmWalletBuy.getIn(['orderConfirmationNotSuccessful']),
                );
        } else {
            notSuccessful = immCmWalletBuy
                .getIn(['orderValidation', 'portfolioOrderValidTransferNok'])
                .concat(
                    immCmWalletBuy.getIn(['orderConfirmationNotSuccessful']),
                );
        }

        notSuccessful = isTransferWithMoney
            ? notSuccessful.concat(orchestratorKoValidationAndConfirmation)
            : notSuccessful;
        return notSuccessful;
    }

    buildFundsDetailsNoK(notSuccessful) {
        const { immCmWalletBuy, onLegalDocumentClick } = this.props;
        const minAmounts = immCmWalletBuy.get('minAmounts');
        const isTransferWithMoney = immCmWalletBuy.getIn([
            'steps',
            CM_WIZARD_FIRST_STEP,
            'isTransferWithMoney',
        ]);

        let notSuccessfulDiv;

        if (notSuccessful.size > 0) {
            notSuccessfulDiv = (
                <div className="cm-model-wallet-success__successful-div">
                    <h2 className="cm-model-wallet-success__subtitle">
                        <FormattedText value="brokerCM-walletBuySuccessOrdersError" />
                    </h2>
                    <div className="cm-model-wallet-error__subtitle-text">
                        <FormattedText value="brokerCM-brokerCM_fundsInfoOrdersError" />
                    </div>
                    <CmValidationSummary
                        portfolio={notSuccessful}
                        hideDocument={true}
                        onLegalDocumentClick={onLegalDocumentClick}
                        isTransferWithMoney={isTransferWithMoney}
                        showBuyButton={true}
                        hasFundProductLink={true}
                        minAmounts={minAmounts}
                    />
                </div>
            );

            return (
                <div className="cm-model-wallet-success__unsuccessful-transfer">
                    <ContentBox>
                        <div className="cm-model-wallet-success__center-panel row">
                            <div className="col-lg-12">{notSuccessfulDiv}</div>
                        </div>
                    </ContentBox>
                </div>
            );
        }
    }

    buildFamilyAccountInfo(familyCCInfoTitle, familyAccount) {
        return (
            <div className="cm-wallet-buy-step2__info-item col-lg-12 col-sm-12 col-xs-12">
                <span className="cm-wallet-buy-step2__info-title">
                    {familyCCInfoTitle}
                </span>
                <span className="cm-wallet-buy-step2__info-body">
                    {getLastNChars(familyAccount)}
                </span>
            </div>
        );
    }

    buildContractInfo(contractInfoTitle, contract, amount) {
        const cmApiNumber = `${CM_API_ENTERPRISE_NUMBER} ${CM_API_CENTER} `;
        const fullContractNumber = cmApiNumber.concat(
            contract.get('productNumber'),
            contract.get('contractNumber'),
        );
        const amountBlock = (
            <FormattedTextWithComponents
                value="brokerCM-walletBuyStep2AvailableAmount"
                className="cm-wallet-buy-step2__info-body"
                injectedComponents={[
                    <OneLineSymbolAmount
                        amountObject={amount}
                        key="cmWalletBuyStep2AvailableAmount"
                        language={getLanguage()}
                        amountObjectFormatted={formatAmountObject(
                            amount.toJSON(),
                            true,
                        )}
                    />,
                ]}
            />
        );

        return (
            <div className="cm-wallet-buy-step2__info-item col-lg-12 col-sm-12 col-xs-12">
                <span className="cm-wallet-buy-step2__info-title">
                    {contractInfoTitle}
                    <span className="cm-wallet-buy-step2__info-body">
                        {fullContractNumber}
                    </span>
                    {amountBlock}
                </span>
            </div>
        );
    }

    buildTransferContractInfo() {
        const { immCmWalletBuy, immAccounts } = this.props;
        const typeMoney = immCmWalletBuy.get('buyType') === CM_BUY_TYPE_MONEY;
        const accountNumber = typeMoney
            ? immCmWalletBuy.getIn([
                  'steps',
                  CM_WIZARD_FIRST_STEP,
                  'accountNumber',
              ])
            : immCmWalletBuy.getIn([
                  'steps',
                  CM_WIZARD_FIRST_STEP,
                  'accountNumberTransfer',
              ]);
        const account = immAccounts.getIn(['byId', accountNumber]);
        const familyCCInfoTitle = account.get('alias');
        const contractNumber = getLastNChars(account.get('contractNumber'));
        const amountTitle = formatText(
            'brokerCM-transferOriginContractsSummaryBalanceLeftHeader',
        );
        const availableBalance = account.getIn([
            'balances',
            'availableBalance',
        ]);
        const associatedAccountBalance = getPlainAmountObject(availableBalance);
        const amountFormatted = (
            <OneLineSymbolAmount
                amountObject={associatedAccountBalance}
                language={getLanguage()}
                amountObjectFormatted={formatAmountObject(
                    associatedAccountBalance,
                    true,
                )}
            />
        );

        return (
            <div className="cm-wallet-buy-step2__info-item col-lg-12 col-sm-12 col-xs-12">
                <span className="cm-wallet-buy-step2__info-title">
                    {familyCCInfoTitle}
                    <span className="cm-wallet-buy-step2__info-body-transfer">
                        {contractNumber}
                    </span>
                </span>
                <span className="cm-wallet-buy-step2__info-title">
                    {amountTitle}
                    <span className="cm-wallet-buy-step2__info-body-transfer">
                        {amountFormatted}
                    </span>
                </span>
            </div>
        );
    }

    buildForLastInfo() {
        return (
            <div className="cm-model-wallet-success__last-info-container">
                <div className="cm-model-wallet-success__last-info-title">
                    <FormattedText value="brokerCM-brokerCM_buySuccessLastInfoTitle" />
                </div>
                <div className="cm-model-wallet-success__last-info-wrapper">
                    <div className="cm-model-wallet-success__last-info-item">
                        <i className="icon cm-model-wallet-success__icon cm-model-wallet-success__icon--verify" />
                        <div className="cm-model-wallet-success__last-info-item-title">
                            <FormattedText value="brokerCM-brokerCM_buySuccessLastInfoTitle1" />
                        </div>
                        <div className="cm-model-wallet-success__last-info-item-description">
                            <FormattedText value="brokerCM-brokerCM_buySuccessLastInfoText1" />
                        </div>
                    </div>
                    <div className="cm-model-wallet-success__last-info-item">
                        <i className="icon cm-model-wallet-success__icon cm-model-wallet-success__icon--consult" />
                        <div className="cm-model-wallet-success__last-info-item-title">
                            <FormattedText value="brokerCM-brokerCM_buySuccessLastInfoTitle2" />
                        </div>
                        <div className="cm-model-wallet-success__last-info-item-description">
                            <FormattedText value="brokerCM-brokerCM_buySuccessLastInfoText2" />
                        </div>
                    </div>
                    <div className="cm-model-wallet-success__last-info-item">
                        <i className="icon cm-model-wallet-success__icon cm-model-wallet-success__icon--add" />
                        <div className="cm-model-wallet-success__last-info-item-title">
                            <FormattedText value="brokerCM-brokerCM_buySuccessLastInfoTitle3" />
                        </div>
                        <div className="cm-model-wallet-success__last-info-item-description">
                            <FormattedText value="brokerCM-brokerCM_buySuccessLastInfoText3" />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    buildAccountInfo(step1Info) {
        const { immCmWalletBuy } = this.props;
        const typeMoney = immCmWalletBuy.get('buyType') === CM_BUY_TYPE_MONEY;
        const interveners = typeMoney
            ? step1Info.get('interveners')
            : step1Info.getIn([
                  'originFundInfo',
                  'listadoIntervinientes',
                  'intervinientes',
              ]);
        const intervenersInfoBlock = typeMoney
            ? this.buildIntervenersInfo(interveners)
            : this.buildIntervenersInfoFromFunds(interveners);
        const originFundInfo = immCmWalletBuy.getIn([
            'steps',
            CM_WIZARD_FIRST_STEP,
            'originFundInfo',
        ]);
        const originFund = originFundInfo.get('infoFondosPosicionGlobal');
        const contractInfoBlock = this.buildTransferContractInfo(originFund);

        return (
            <div className="cm-model-wallet-success__info-box-transfer row">
                <h2 className="cm-model-wallet-success__subtitle-account">
                    <FormattedText value="brokerCM-walletBuyStep2AssociatedCC" />
                </h2>
                <div className="cm-model-wallet-success__info--first col-lg-3 col-sm-4 col-xs-12">
                    {contractInfoBlock}
                </div>
                <div className="cm-model-wallet-success__info--last col-lg-9 col-sm-8 col-xs-12">
                    {intervenersInfoBlock}
                </div>
            </div>
        );
    }

    render() {
        const { immCmWalletBuy, immAccounts } = this.props;
        const step1Info = immCmWalletBuy.getIn(['steps', CM_WIZARD_FIRST_STEP]);
        const familyAccount = immAccounts.getIn([
            'byId',
            step1Info.get('accountNumber'),
            'contractNumber',
        ]);
        const accountAlias = immAccounts.getIn([
            'byId',
            step1Info.get('accountNumber'),
            'alias',
        ]);
        const successful = this.buildOKList();
        const fundsDetailsBlock = this.buildFundsDetails(successful);
        const notSuccessful = this.buildNOKList();
        const fundsDetailsBlockNoK = this.buildFundsDetailsNoK(notSuccessful);
        const accountInfoBlock = this.buildAccountInfo(
            step1Info,
            familyAccount,
            accountAlias,
        );
        const mainButtonLabel = formatText(
            'brokerCM-walletBuySuccessButtonLabel',
        );
        const eventTag = immCmWalletBuy.get('eventTag');
        const secondaryButtonLabel = formatText(
            'brokerCM-walletBuySuccessSecondaryButtonLabel',
        );
        const forLastInfoBlock = this.buildForLastInfo();
        const fundsDetailsNotOkNotEmpty =
            notSuccessful && notSuccessful.size > 0;
        let infoBodyText;

        if (immCmWalletBuy.get('buyType') === CM_BUY_TYPE_MONEY) {
            if (fundsDetailsNotOkNotEmpty) {
                infoBodyText = formatText(
                    'brokerCM-brokerCM_walletBuySuccessAndFailedHeaderMessage',
                );
            } else {
                infoBodyText = formatText(
                    'brokerCM-brokerCM_walletBuySuccessHeaderMessage',
                );
            }
        } else {
            if (fundsDetailsNotOkNotEmpty) {
                infoBodyText = formatText(
                    'brokerCM-brokerCM_walletBuySuccessStepHeaderMessage',
                );
            } else {
                infoBodyText = formatText(
                    'brokerCM-brokerCM_walletBuySuccessStepSuccessOrdersHeaderMessage',
                );
            }
        }

        return (
            <div className="cm-model-wallet-success">
                <header className="cm-model-wallet-success__header-transfer">
                    <span className="cm-model-wallet-success__info-body">
                        {infoBodyText}
                    </span>
                </header>
                <CmWizardSuccess
                    eventTag={eventTag}
                    successMessage=""
                    successSubMessage=""
                    customClassName="cm-model-wallet-success"
                    mainButton={{
                        label: mainButtonLabel,
                        url: CM_BROKER_PG_URL,
                        modifier: 'secondary',
                    }}
                    secondaryButton={{
                        label: secondaryButtonLabel,
                        url: CM_CUSTOM_WALLET_CONFIG_URL,
                    }}
                    secondaryButtonStyle="ghost"
                >
                    <ContentBox>
                        <div className="cm-model-wallet-success__center-panel row">
                            <div className="col-lg-12">{fundsDetailsBlock}</div>
                        </div>
                    </ContentBox>
                    {fundsDetailsBlockNoK}
                    <div className="cm-model-wallet-success__center-panel cm-model-wallet-success__account-info-wrapper">
                        <div className="cm-model-wallet-success__account-info-box">
                            {accountInfoBlock}
                        </div>
                    </div>
                    <div className="cm-model-wallet-success__center-panel cm-model-wallet-success__last-info-box">
                        {forLastInfoBlock}
                    </div>
                    <div className="cm-model-wallet-success__box-divider-last"></div>
                </CmWizardSuccess>
            </div>
        );
    }
}

CmWalletBuySuccess.propTypes = {
    immCmWalletBuy: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    onLegalDocumentClick: PropTypes.func.isRequired,
};

module.exports = CmWalletBuySuccess;
